import { Button, message } from "antd";
import { appManager } from "../../../service/app-manager/AppManager";
import { ProjectInfo } from "../../../service/project-manager/ProjectManager";
import { useApps } from "../create-project/util/useApp";
import styles from "./OpenProject.module.scss"
import { useProjects, useOpenProject } from "./util/useProject";
import { useTranslation } from "react-i18next";
import confirm from "antd/es/modal/confirm";

const PROJECT_TYPES = {
  coding: 'projects.coding',
  model: 'projects.model',
  ui: 'projects.view'
};

export const OpenProject = () => {
    const {apps} = useApps()
    const {projects} = useProjects();
    const {openLocalProject} = useOpenProject();
    const { t } = useTranslation();

    const onOpenLocalProject = async () => {
        console.log('暂无功能')
        message.warning({
            content: t('onlines_unsupported') as string,
            className: styles.message,
        });
        return;
        // // 纯React版本：使用input元素选择文件
        // const input = document.createElement('input');
        // input.type = 'file';
        // input.multiple = false;
        
        // // 设置文件过滤器
        // const extensions = apps.filter(item => item.fileExtension).flatMap(item => 
        //     item.fileExtension.map(ext => ext.replace(".", ""))
        // );
        // const uniqueExtensions = Array.from(new Set(extensions));
        // input.accept = uniqueExtensions.map(ext => `.${ext}`).join(',');
        
        // input.onchange = async (e) => {
        //     const file = (e.target as HTMLInputElement).files?.[0];
        //     if (!file) return;
            
        //     const projectPath = file.name;
        //     const ext = '.' + file.name.split('.').pop();
            
        //     if (ext) {
        //         // 查找对应的应用
        //         const app = apps.find(app => 
        //             app.fileExtension?.includes(ext)
        //         );
                
        //         if (app) {
        //             openLocalProject(app.id, projectPath);
        //         } else {
        //             message.error(t('open_project_failed') as string);
        //         }
        //     } else {
        //         message.error(t('open_project_failed') as string);
        //     }
        // };
        
        // input.click();
    }

    const onOpenProject = (project: ProjectInfo) => {
        if (project.type === "local") {
            openLocalProject(project.appId, project.path)
        }
    }

    // 清空所有项目记录
    const onClearProjects = () => {
        const modal = confirm({
            type: 'confirm',
            centered: true,
            title: t('clear') as string,
            content: t('clear_all_project_records') as string,
            footer: <>
                <div className={styles.confirmButton}>
                    <button onClick={() => {
                        // 纯React版本：清空localStorage中的项目记录
                        localStorage.removeItem('mindplus-projects');
                        // 重新加载项目列表
                        window.location.reload();
                        modal.destroy();
                    }} >{t('confirm') as string}</button>
                    <button onClick={() => modal.destroy()} >{t('cancel') as string}</button>
                </div>
            </>,
        });
    }
    
    return (
        <div className={styles.openProject}>
            <div className={styles.openFile}>
                <div className={styles.fileContainer}>
                    <div className={styles.title}>{t('local_project_files') as string}</div>
                    <div className={styles.open} onClick={onOpenLocalProject}>
                        <img src="/home/local-file.png" className={styles.localIcon}/>
                        <div className={styles.openFileText}>{t('open_local_file') as string}</div>
                    </div>
                </div>
                <div className={styles.fileContainer} style={{visibility: 'hidden'}}>
                    <div className={styles.title}>{t('cloud_project_files') as string}</div>
                    <div className={styles.open}>
                        <img src="/home/cloud-file.png" className={styles.cloudIcon}/>
                        <div className={styles.openFileText}>{t('open_cloud_file') as string}</div>
                    </div>
                </div>
            </div>
            <div className={styles.titleContainer}>
                <div className={styles.title}>{t('historical_projects') as string}</div>
                <div className={styles.clear} onClick={onClearProjects}>{t('clear_history') as string}</div>
            </div>
            <div className={styles.historyProjects}>
                {projects.map((item, index) => {
                        return <div key={index} className={styles.projectCard} onClick={()=>onOpenProject(item)}>
                            <div className={styles.projectCardHeader}>
                                <div className={styles.projectIcon} 
                                style={{ backgroundImage: item.type === "cloud" ? 
                                    `url(${item.cover})` : 
                                    'url("/project-default-cover.png")' }}
                                
                                > </div>
                                <div className={styles.projectName} >{item.name}</div>
                            </div>
                            <div className={styles.projectCardDetails}>
                                <div className={styles.projectUpdateTime} > {t('updated_at') as string}{new Date(item.updateTime).toLocaleDateString()}</div>
                            </div>
                    </div>
                })}
            </div>
        </div>
    )
}